import * as React from "react";
import { toastr } from "react-redux-toastr";
import classnames from "classnames";
import { usePerformAction } from "react-remote-data-hooks";
import api from "../../../../api";
import { Dict, Settings, LeadType } from "../../../../core";
import { useMasterData } from "../../../../core/hooks/useMasterData";
import OnlineLeadsCreateForm from "./OnlineLeadsCreateForm";
import { ContainerLoader } from "../../../../components/loader";

const OnlineLeads: React.FunctionComponent<{
  onReload: () => void;
  settings: Settings;
}> = (props) => {
  const masterData = useMasterData(api.settings);

  const [editModal, setEditModal] = React.useState<{
    isOpen?: boolean;
    data?: LeadType;
  }>({});

  const [error, setError] = React.useState<any>();

  const {
    performAction: createVisibilityGroup,
    isPerforming: isCreating,
  } = usePerformAction(
    (q: Dict) => {
      setError("");
      return api.settings.updateOnlineLead(q);
    },
    () => {
      props.onReload?.();
      setEditModal({});
      toastr.success("Success", "Updated successfully");
    },
    () => {
      toastr.error("Error", "Failed to update");
    }
  );

  const update = (group: Dict) => {
    createVisibilityGroup(group);
  };

  return (
    <>
      <div className="col-lg-4 col-md-6 col-12 border-right">
        <div className="d-flex align-items-center py-3">
          <div className="col-auto">
            <h4 className="mb-0 font-weight-semibold">Online Leads</h4>
          </div>
        </div>
        <div className="grid-table grid-table--sm border-top">
          <table>
            <thead>
              <tr>
                <th>
                  <span className="d-inline-flex align-items-center">
                    Lead Type
                  </span>
                </th>
                <th>
                  <span className="d-inline-flex align-items-center">
                    Visibility Mapping Status
                  </span>
                </th>
              </tr>
            </thead>
            <tbody>
              {(!masterData.loaded || masterData.loading) && (
                <ContainerLoader></ContainerLoader>
              )}
              {masterData?.data?.leadTypes?.map((item) => {
                const sob = props.settings?.onlineLeadsVisibilityGroups?.leadTypes
                  ?.find((x) => x.leadType === item._id)
                  ?.sourceofBusinesses?.filter(
                    (s) => !!s.sobVisibilityGroups?.length
                  );
                return (
                  <tr
                    onClick={() => setEditModal({ isOpen: true, data: item })}
                    className={classnames({
                      "cursor-pointer": true,
                      "text-blue": editModal?.data?._id === item?._id,
                    })}
                  >
                    <td>{item.name}</td>
                    <td>
                      {sob?.length || 0}/{masterData?.data?.leadSources?.length}{" "}
                      <span
                        className={classnames({
                          dot: true,
                          "dot--green":
                            sob?.length ===
                            masterData?.data?.leadSources?.length,
                          "dot--red":
                            sob?.length !==
                            masterData?.data?.leadSources?.length,
                        })}
                      ></span>
                    </td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        </div>
      </div>
      <div className="col-lg col-md-6 col-12 p-2 setting-detail-block left-0 top-0 bg-white w-100 h-100 zIndex-1">
        {editModal.isOpen && (
          <>
            <div className="text-right d-md-none">
              <i className="icon-close"></i>
            </div>
            <OnlineLeadsCreateForm
              key={"OwnerUnassignedEntitiesEdit"}
              onSubmit={update}
              isSubmitting={isCreating}
              error={
                error
                  ? error.response?.message || `Unable to update`
                  : undefined
              }
              data={props.settings?.onlineLeadsVisibilityGroups}
              onCancel={() => setEditModal({})}
              leadType={editModal.data}
            ></OnlineLeadsCreateForm>
          </>
        )}
      </div>
    </>
  );
};

export default OnlineLeads;